// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import McMcApplicationState from "@mcmc/App/Store/McMcApplicationState";
import { getQuickShipIconUrl } from "@mcmc/App/Store/Selectors/ProductDetailsSelectors";
import LazyImage, { LazyImageProps } from "@mcmc/MobiusOverrides/LazyImage";
import { screen } from "@mcmc/XDL/Helpers";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type OwnProps = WidgetProps & HasProduct;

const mapStateToProps = (state: McMcApplicationState, props: OwnProps) => ({
    quickShipIconUrl: getQuickShipIconUrl(state, props.product),
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface ProductDetailsQuickShipStyles {
    quickShipIcon?: LazyImageProps;
}

export const productDetailsQuickShipStylesStyles: ProductDetailsQuickShipStyles = {
    quickShipIcon: {
        css: css`
            align-items: flex-start;
            width: 265px;
            margin: 20px 0 0;
            ${screen("lte", "sm")`
                margin: 0 0 20px;
           `}
        `,
    },
};

const styles = productDetailsQuickShipStylesStyles;

const ProductDetailsQuickShip: React.FC<Props> = ({ quickShipIconUrl }) => {
    if (!quickShipIconUrl) {
        return null;
    }

    return (
        <LazyImage
            src={quickShipIconUrl}
            altText={translate("Product Details Quick Ship Icon")}
            {...styles.quickShipIcon}
        />
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps)(ProductDetailsQuickShip)),
    definition: {
        displayName: "Product Quick Ship Icon",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
    },
};

export default widgetModule;
